import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import Blamable            from '@/models/traits/Blamable';
import { Timestampable }   from '@widesk-core/decorators/timestampable';

@doc.urnResource('event_status')
@doc.path('/event_statuses/{?id}')
@doc.timestampable
abstract class AbstractEventStatusModel extends Blamable(WebsiteServiceModel) {
	declare protected _tsFilters: {
		'createdAt[before]': string | Date;
		'createdAt[strictly_before]': string | Date;
		'createdAt[after]': string | Date;
		'createdAt[strictly_after]': string | Date;
		'updatedAt[before]': string | Date;
		'updatedAt[strictly_before]': string | Date;
		'updatedAt[after]': string | Date;
		'updatedAt[strictly_after]': string | Date;
		'reference': Website_EventStatusReference;
		'search': string;
	};

	declare private _tsSorts: {
		id: string;
		reference: string;
		label: string;
		createdAt: string;
		updatedAt: string;
	};

	@doc.string declare reference: Website_EventStatusReference;
	@doc.string declare label: string;
}

interface AbstractEventStatusModel extends Timestampable {}

export default AbstractEventStatusModel;
